import { useEffect, useState } from "react";
import formatMoney from "../../../../../formatMoney";

function NetSummary({ net, vat }) {
  return (
    <>
      <div className="d-flex flex-column card p-3">
        <div className="d-flex justify-content-between">
          <p className="m-0 text-muted">Net VATable Value:</p>
          <div
            className="d-flex gap-2 fw-bold text-truncate"
            style={{ maxWidth: "200px" }}
          >
            &#8369;
            <p className="m-0 text-truncate">{net || "0.00"}</p>
          </div>
        </div>

        <div className="d-flex justify-content-between">
          <p className="m-0 text-muted">VAT Value:</p>
          <div
            className="d-flex gap-2 fw-bold text-truncate"
            style={{ maxWidth: "200px" }}
          >
            &#8369;
            <p className="m-0 text-truncate">{vat || "0.00"}</p>
          </div>
        </div>
      </div>
    </>
  );
}

export default NetSummary;
